<div nz-row nzJustify="center" nzAlign="middle" class="wrapper">
  <div nz-col nzSpan="24">
    <nz-spin [nzSpinning]="isLoading$ | async" [nzTip]="loadingTip$ | async" [nzSize]="'large'">
      <nz-layout>
        <nz-content class="centered">
          <div nz-row [nzGutter]="[0, 32]" class="login-box">
            <div nz-col nzSpan="24">
              <img class="logo" src="assets/img/teamsystem.png"/>
            </div>
            <div nz-col nzSpan="24">
              <h1 i18n="Auth.Login.Title|title for login page@@Auth.Login.Title">Accedi a Self Care</h1>
            </div>
            <ng-container
              [ngSwitch]="step$ | async"
            >
              <ng-container
                *ngSwitchCase="LoginStep.UsernameAndPassword"
              >
                <app-username-password
                  [onLogin]="onLogin"
                ></app-username-password>
              </ng-container>
              <ng-container
                *ngSwitchCase="LoginStep.Level2Recognition"
              >
                <app-level2-otp-generator-choice
                  [level2OtpGenerators]="otpDeliveryMethod$ | async"
                  [onClickCard]="onClickCard"
                  (onBack)="onBack($event)"
                ></app-level2-otp-generator-choice>
              </ng-container>
              <ng-container
                *ngSwitchCase="LoginStep.Otp"
              >
                <app-otp-input
                  [selectedLevel2OtpGenerator]="selectedOtpDeliveryMethod$ | async"
                  [onLoginWithOtp]="onLoginWithOtp"
                ></app-otp-input>
              </ng-container>
            </ng-container>
          </div>
        </nz-content>
      </nz-layout>
    </nz-spin>
  </div>
</div>
